// A free-field date of "0" represents an empty date.
export const isFreeFieldDateEmpty = (value: string): boolean => !value || value === "0";

// Percentage free fields store 50% as "50", while percentage inputs use 0.5.
export const parseFreeFieldPercentage = (value: string): number => parseFloat(value) / 100;

export const toFreeFieldPercentageValue = (value: number): number => value * 100;

export const freefieldKeyPrefix = "freefieldId-";
export const isFreefieldKey = (key: string): boolean => {
  return key.startsWith(freefieldKeyPrefix);
}

export const getFreefieldId = (key: string): number => {
  if (!isFreefieldKey(key)) {
    throw new Error(`Key ${key} is not a freefield key`);
  }
  return parseInt(key.substring(freefieldKeyPrefix.length));
}

export const isEmpty = (displayValue: string, type: server.dto.FormElementTypes): boolean => {
  if (type === "date" || type === "dateTime" || type === "time") {
    return isFreeFieldDateEmpty(displayValue);
  }

  return !displayValue;
}

export const clearableTypes: server.dto.FormElementTypes[] = ["dropdown"];
